import { Component, inject, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { EdiWrapperTile, EdiWrapperTilesService } from './edi-wrapper-tiles.service';

@Component({
  selector: 'lib-edi-wrapper',
  templateUrl: './edi-wrapper.component.html',
  styleUrls: ['./edi-wrapper.component.css'],
  standalone: false
})
export class EdiWrapperComponent implements OnInit {
  protected router = inject(Router);
  protected authService = inject(AuthService);
  protected backendFeatureService = inject(BackendFeatureService);
  protected ediWrapperTilesService = inject(EdiWrapperTilesService);

  minimize = false;
  isActuator = false;
  incomingOrderResponsesEnabled = false;
  pricatsEnabled = false;
  extraTiles: EdiWrapperTile[] = [];

  constructor() {
    this.router.events
      .pipe(
        filter(event => event instanceof ActivationEnd),
        filter(event => (event as ActivationEnd).snapshot.component === EdiWrapperComponent),
        map(event => (event as ActivationEnd).snapshot.children.length),
        distinctUntilChanged()
      )
      .subscribe(children => (this.minimize = children !== 0));
    this.minimize = !this.router.url.endsWith('/edi');

    this.backendFeatureService.isActivated('gung-feature-edi.incoming-order-responses').subscribe(isActivated => {
      if (isActivated) {
        this.incomingOrderResponsesEnabled = true;
      }
    });

    this.backendFeatureService.isActivated('gung-feature-edi.pricats').subscribe(isActivated => {
      if (isActivated) {
        this.pricatsEnabled = true;
      }
    });
  }

  ngOnInit() {
    this.authService.getHasRoles('ACTUATOR').subscribe(isActuator => (this.isActuator = isActuator));
    this.extraTiles = this.ediWrapperTilesService.getExtraTiles();
  }
}
